module.exports = {
  "addMenuItem": {
    "name": "advancedMenusInteraction",
    "class": "interaction",
    "properties": {
      "type": [
        "NO_LINK",
        "PAGE_LINK",
        "URL_LINK",
        "PAGE_LINK_WITH_PARAMS"
      ],
      "method": [
        "button",
        "divider"
      ]
    },
    "namespace": "advanced-menus",
    "version": "1"
  }
};